import { jsx as _jsx } from "react/jsx-runtime";
import { PosAttributeDraftViewModel, PosAttributeTree, } from "@lumora/core";
import { useMemo } from "react";
import { PosDeepAttributePanel } from "../pos/PosDeepAttributeViews.js";
import { POS_LABEL_KEYS } from "../pos/posLabels.js";
import { useViewModel } from "../react/useViewModel.js";
import { selectionLabels } from "./attributeLines.js";
/** English defaults for the words the shared attribute panel prints (sites may override any). */
export const ORDERING_ATTRIBUTE_LABELS = {
    ...Object.fromEntries(POS_LABEL_KEYS.map((k) => [k, ""])),
    required: "Required",
    optional: "Optional",
    chooseOne: "Choose an option to continue.",
    lineTotal: "Item total",
    add: "Add to order",
    close: "Close",
    back: "Back",
    kwNo: "NO",
    done: "Done",
};
/**
 * Website add-to-cart picker for an item with `attributes`. The shared deep-attribute panel
 * (popup stack or scroll tree) driven by a PosAttributeDraftViewModel; confirm yields a cart product
 * carrying `selections` and the rolled-up unit price. The server re-prices every line.
 */
export function OrderingAttributePicker({ item, layout = "popup-stack", density, labels, lang = "en", onConfirm, onClose, }) {
    const { posItem, vm } = useMemo(() => {
        const roots = PosAttributeTree.parse(item.attributes ?? []).roots;
        const posItem = { priceCents: item.priceCents, attributes: roots };
        return { posItem, vm: new PosAttributeDraftViewModel(posItem) };
    }, [item]);
    const state = useViewModel(vm);
    const merged = { ...ORDERING_ATTRIBUTE_LABELS, ...labels };
    const confirm = () => {
        if (!vm.state.valid)
            return;
        const selections = vm.payload();
        const labelsOut = selectionLabels(posItem.attributes, vm.state.selections, vm.state.hiddenPaths, merged.kwNo);
        onConfirm({
            id: item.id,
            name: item.name,
            priceCents: item.priceCents,
            unitPriceCents: vm.state.unitPriceCents,
            ...(selections.length > 0 ? { selections: [...selections] } : {}),
            ...(labelsOut.length > 0 ? { selectionLabels: labelsOut } : {}),
        });
    };
    return (_jsx("div", { className: "lumora-order-attrs", "data-layout": layout, onKeyDown: (e) => {
            if (e.key === "Escape")
                onClose();
        }, children: _jsx(PosDeepAttributePanel, { draft: {
                vm,
                state,
                item: posItem,
                title: item.name,
                layout,
                ...(density ? { density } : {}),
                onConfirm: confirm,
                onClose,
            }, labels: merged, lang: lang }) }));
}
//# sourceMappingURL=OrderingAttributePicker.js.map